<dynamic-material-form
  #form
  [model]="formModel"
  [group]="formGroup"
  (change)="onFormChange()"
  (keydown)="onFormChange()"
  (matEvent)="onCustomEvent($event, null, true)"
  data-test="gsm-data-array_form"
>
  <ng-template modelType="ARRAY" let-index="index">
    <button
      *ngIf="model.editable && !model.disabled"
      class="gsm-data-array_delete-btn"
      mat-icon-button
      title="Entfernen"
      (click)="removeItem(index)"
      data-test="gsm-data-array_delete-btn"
    >
      <mat-icon>delete</mat-icon>
    </button>
  </ng-template>
</dynamic-material-form>
<div *ngIf="model.editable && !model.disabled" class="buttons-container">
  <div class="add-button-container inline-flex" (click)="addItem()">
    <button mat-mini-fab class="add-button" color="primary" data-test="gsm-data-array_add-btn">
      <mat-icon>add</mat-icon>
    </button>
    <span data-test="gsm-data-array_add-btn-label">{{ model.addButtonLabel }}</span>
  </div>
</div>
